import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const TriangleDownSmall = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      fill-rule="nonzero"
      d="m12.461 14.782 4.456-6.073c.16-.217.082-.503-.173-.639a.615.615 0 0 0-.288-.07H7.544c-.3 0-.544.207-.544.463 0 .087.029.172.083.246l4.456 6.073c.159.217.494.283.75.148a.511.511 0 0 0 .172-.148Z"
    />
  </SvgIcon>
);

export default TriangleDownSmall;
